import React from "react";
import Nav from "../../components/nav";
import Footer from "../../components/footer";
import Webinarph from '../../assets/pic/webinar.jpg';
import {Helmet} from "react-helmet";

const Webinar = ()=>{
    return(
        <div className='webinar-wrap'>
            <Helmet>
                <title>وبینار</title>
                <meta name="description" content="وبینار همان سمیناری است که به صورت آنلاین (اینترنتی) برگزار می‌شود. در واقع واژه وبینار (Webinar) از Web – based Seminar گرفته شده و به معنی سیمنار بتنی بر وب است. پس اگر سیمناری را بر بستر اینترنت و به صورت کاملاً آنلاین (بدون وقفه زمانی) برگزار کنید، اصطلاحاً در حال برگزاری یک وبینار هستید." />
            </Helmet>
            <Nav />
            <div className='webinar-dec'>
                <h1>وبینار</h1>
                <img src={Webinarph} alt="وبینار"/>
                <p>
                    احتمالا این روزها واژه وبینار را زیاد شنیده و پرسیده باشید که وبینار چیست. برای پاسخ به این سوال، به صورت خیلی ساده و خلاصه می‌توان گفت که وبینار همان سمیناری است که به صورت آنلاین (اینترنتی) برگزار می‌شود. در واقع واژه وبینار (Webinar) از Web – based Seminar گرفته شده و به معنی سیمنار بتنی بر وب است. پس اگر سیمناری را بر بستر اینترنت و به صورت کاملاً آنلاین (بدون وقفه زمانی) برگزار کنید، اصطلاحاً در حال برگزاری یک وبینار هستید. لازم به ذکر است که وبینار به رویداد آنلاین نیز موسوم است.
                </p>
                <p>
                    یک ویبنار یا سمینار آنلاین استاندارد باید دارای یک سری امکانات به قرار زیر باشد.
                </p>
                <ul>
                    <li>•	امکان تعامل دو طرفه میان میزبان و شرکت کنندگان به صورت ویدئویی و صوتی</li>
                    <li>•	امکان به اشتراک گذاری فایل</li>
                    <li>•	امکان اشتراک گذاری صفحه نمایش </li>
                    <li>•	امکان نمایش ویدئو</li>
                    <li>•	وجود تخته سیاه و امکان دانلود آن برای شرکت کنندگان</li>
                    <li>•	وجود محیط گفت و گو (چت) برای شرکت کنندگان</li>
                </ul>
                <br/>
                <p>
                    چنین امکاناتی از طریق یک نرم افزار یا سرویس تحت وب در اختیار کاربران قرار می‌گیرد. این سرویس می‌تواند به صورت یک نرم‌افزار روی دستگاه شما نصب و یا از طریق مرورگر (Browser) در دسترس باشد.
                </p>
                <p>
                    با این اوصاف تنها امکانات لازم جهت برگزاری و یا شرکت در یک وبینار، یک دستگاه متصل به ایترنت (لپ تاپ، تبلت یا موبایل) است. البته جهت برگزاری یک وبینار حرفه‌ای داشتن دوربین، میکروفون و هدست ثانویه جهت ارسال و دریافت با کیفیت پیشنهاد می‌شود.
                </p>
                <br/>
                <h2>کاربرد وبینار</h2>
                <p>
                    می‌توان گفت که ویبنار همان اهداف یک سمینار سنتی را دنبال می‌کند. تنها تفاوت وبینار با یک سمینار سنتی نحوه برگزاری آن است. به همین جهت، برگزاری کارگاه‌های آموزشی و همایش‌ها با رویکردهای آموزشی‌، بازاریابی، اطلاع رسانی و تبادلات علمی همه کاربردهایی از وبینار یا همان سمینار آنلاین به شمار می‌روند.
                </p>
                <p>
                    در همین بخش یکی از برتری‌های وبینار نسبت به سمینار سنتی نمایان است و آن چیزی جزء عدم وابستگی به مکان و زمان نیست. عدم وابستگی به مکان علاوه بر اینکه امکان شرکت در سیمنار آنلاین را از هر شهر و کشوری برای شرکت کنندگان فراهم می‌کند، این امکان را برای میزبان فراهم می‌کند تا سیمنار را در مقیاسی بزرگتر و با تعداد شرکت کننده بیشتر برگزار کند.
                </p>
                <p>
                    عدم وابستگی به زمان نیز امکان برگزاری سیمنار را در ساعات دلخواه و مد نظر شرکت کنندگان فراهم می‌کند. از آنجایی که عموم شرکت کنندگان شاغل و یا دانشجو هستند، امکان ترک شغل و یا کلاس درس را در ساعات صبح و ظهر ندارند. به همین جهت می‌توان سمینار آنلاین را در ساعات بعد از ظهر و شب برگزار کرد تا رضایت نسبی از وبینار (سیمنار آنلاین) بیشتر شود.
                </p>
                <br/>
                <h2>مزایای وبینار </h2>
                <p>
                    همان‌طور که پیشتر عنوان شد، امکانات یک پلتفرم جامع وبینار و عدم وابستگی به مکان و زمان از مهم‌ترین مزایای ترجیح وبینار نسبت به یک سمینار سنتی (حضوری) است. در ادامه با نگاه دقیق‌تری به مزایای وبینار می‌پردازیم.
                </p>
                <br/>
                <h2>سیمنار بدون مرز !</h2>
                <p>
                    راحتی حضور در یک رویداد، نبود صف‌های طولانی ثبت بیلیت و پذیریش، نبود ترافیک در طول مسیر، وجود جای پارک خودرو و ... از عوامل تاثیر گذار جهت ترغیب عموم افراد برای جضور در یک رویداد یا سمینار هستند. همچنین ممکن است که خیلی از افراد علاقه‌مند به شرکت در رویداد به دلیل دوری مسافت و برگزاری در یک شهر یا کشور دیگر، از شرکت در آن منصرف شوند. به طور خلاصه، یک سمینار سنتی (حضوری) تنها یک جامعه آماری کوچکی را می‌تواند پوشش دهد.
                </p>
                <p>
                    همه مشکلاتی که در فوق به آن‌ها اشاره کردیم، با برگزاری یک سیمنار آنلاین یا همان وبینار قابل رفع است. همه افراد با هر موقعیت جغرافیایی، تنها با اتصال به اینترنت می‌توانند در سیمنار شرکت کرده و از محتوای آن بهره‌مند شوند. در این صورت مخاطبین سیمنار شما می‌توانند از هر شهر و یا حتی کشوری باشند.
                </p>
                <br/>
                <h2>تعامل میزبان و شرکت کننده</h2>
                <p>
                    پیشتر امکانات یک پتلفرم جامع وبینار یا رویداد آنلاین را عنوان کردیم. وجود محیط گفت‌و‌گو (چت)، دوربین (وب کم) و میکروفون باعث افزایش تعامل میزبان با شرکت کنندگان و همچنین شرکت کنندگان با یکدیگر می‌شوند. تمامی این امکانات، ارتباط دو طرفه آنلاین را برای افراد فراهم می‌کنند.
                </p>
                <br/>
                <h2>اشتراک گذاری منابع و ذخیره سمینار !</h2>
                <p>
                    به جز دوبین، میکروفون و محیط چت، امکانات دیگری از یک پلتفرم جامع وبینار، باعث افزایش تعامل میزبان و شرکت کننده می‌شوند. در پلتفرم وبینار این امکان وجود دارد که محتوای ارائه نظیر فایل‌های PowerPoitn، PDF، ویدئو‌ها و ... در اختیار شرکت کنندگان قرار بگیرد که همین امر موجب افزایش تعامل و آمادگی ذهنی شرکت کنندگان می‌شود.
                </p>
                <p>
                    همچنین از آنجایی که افراد در حین برگزاری سمینار به محتوا دسترسی دارند، بازدهی آن برای شرکت کنندگان نیز بیشتر می‌شود.
                </p>
                <p>
                    همچنین میزبان و شرکت کننده امکان ذخیره صفحه نمایش و در نتیجه ذخیره سمینار را دارند. این امر موجب می‌شود تا به محتوای ارائه شده و صحبت‌های میزبان برای همیشه دسترسی داشت. همچنین اگر افرادی امکان شرکت در وبینار را در ساعات برگزاری نداشته باشند، با ذخیره آن در فرصت‌های بعدی آن را تماشا کنند.
                </p>
                <br/>
                <h2>کاهش هزینه و صرفه جویی در زمان</h2>
                <p>
                    برگزاری یک وبینار از این حیث که برای آن نیازی به فضا و سالن‌های بزرگ، تجهییزات صوتی و تصویری، استخدام خدمه، پذیرایی و ... نیست، کاهش چشم گیری در مقدار هزینه‌های میزبان دارد. همین امر موجب می‌شود تا قیمت تیکت شرکت در وبینار (سمینار آنلاین) برای شرکت کنندگان نیز کاهش چشم گیری داشته باشد که به دنبال آن جامعه آماری بیشتری می‌توانند مخاطب وبینار شما باشند.
                </p>
                <p>
                    جدا از قیمت پایین‌تر تیکت شرکت در وبینار، حذف رفت و آمد نیز می‌تواند منجر به کاهش هزینه‌ها و البته صرفه جویی در زمان شود.
                </p>
                <br/>
                <h2>اصلی‌ترین عیب وبینار</h2>
                <p>
                    شاید بتوان گفت اصلی‌ترین و البته تنها ایراد وبینار، وابستگی کیفیت آن به زیرساخت‌های ارتباطی و اینترنت باشد. برای آنکه تمامی امکانات پلتفرم جامع وبینار نظیر اتصال چندین دوربین ، نمایش ویدئو و ... با بهترین کیفیت و بدون تاخیر نمایش داده شوند، نیاز به اینترنت با سرعت مناسب است.
                </p>
                <p>
                    البته خوشبختانه با پیشرفت تکنولوژی ارتباطی نظیر 4G/LTE ، 5G و فیبر نوری و همچنین افزایش پوشش اینترنتی این ایراد روز به روز کمرنگتر شده و در مقابل بر کیفیت خدمات وبینار که به پهنای باند بالایی نیاز دارند، نظیر برقراری ارتباط زنده HD و 4K، افزوده می‌شود.
                </p>
                <p>
                    امروزه بستر و یا پلتفرم‌های مختلفی جهت برگزاری وبینار وجود دارند. با توجه با محدودیت‌هایی که عموم پلتفرم‌های خارجی در کشور عزیزمان ایران دارند، پلتفرم جامع، بومی و دانش بنیان بل میت (BellMeet) با تمامی امکانات استانداردی که در فوق به آن‌ها اشاره کردیم، می‌تواند گزینه‌ای ایده‌آل جهت برگزاری وبینار، وب کنفرانس، آموزش آنلاین، کلاس آنلاین و ... شما باشد.
                </p>
            </div>
            <Footer />
        </div>
    )
}

export default Webinar